import TopBar, {getCCStatusModel} from '@bnr-dev/topbar/dist';
import {createApp, h, reactive, ref, defineEmits} from 'vue';
import {fetchTranslations, initTranslations} from "@bnr-dev/translate";
import "@bnr-dev/topbar/dist/index.css";
import ServiceContainer from "@/bnr-common-web/services/ServiceContainer.js";
import commonFrontendTranslations from '../../../../public/json/common-frontend-translations.json';

let i18n;
let selectedCentralIds = [];
let enabled = false;

const simpleLocalizeOttUiCommonToken = "871890add0b24067883679bea521b926";

const webOttUrl = import.meta.env.VITE_ENV_WEB_OTT_URL;
const ccStatus = getCCStatusModel();

const props = reactive({
    webOttUrl: webOttUrl,
    centralOptions: [],
    onCentralsChanged: (centrals) => {
        selectedCentralIds = centrals.map((central) => central.id);
        updateWsContext();
    },
    translate: (key) => i18n ? i18n.global.t(key) : key,
    enabled: false,
    isWebexMasterPage: false,
    modelValue: ref(ccStatus),
    userHasCCModule: false,
    openBookingOnPickup: true
});

const app = createApp({
    render: () => h(TopBar, props)
});

const eventListeners = [];
app.provide('webSocketService', {
    addListener: (eventType, callback) => {
        eventListeners.push({
            eventType: eventType,
            callback: callback
        });
    }
});

const serviceContainer = ServiceContainer.getInstance();
app.provide('httpService', serviceContainer.httpService);

app.provide('authorizationService', {
    userHasModule: (moduleId) => {
        return window.appController?.authorizationService?.userHasModule(moduleId);
    },
    getCentralAccess: () => {
        return window.appController?.authorizationService?.getCentralAccess()
    },
    getAllowedCentralsByModule: (centrals, moduleKey) => {
        return window.appController?.authorizationService?.getAllowedCentralsByModule(centrals, moduleKey)
    }
});

const updateWsContext = () => {
    window.appController?.websocketService.sendMonitorContextData(selectedCentralIds, Date.now());
};

function initApp(translationData) {
    if (translationData) {
        i18n = initTranslations([translationData], window.languageCode.substr(0, 2));
        app.use(i18n);
        app.mount('#topbar-app');
    }

    addEventListeners();

    setEnabled();
}

const setup = () => {
    // Fetch translations in setup, to ensure languageCode is set
    fetchTranslations(simpleLocalizeOttUiCommonToken)
        .then(translationData => initApp(translationData))
        .catch(() => initApp(commonFrontendTranslations));
};

function setEnabled() {
    hideIfMonitor();

    props.enabled = window.appController?.tokenService.hasValidAccessToken();
    props.userHasCCModule = window.appController?.authorizationService?.userHasModule('CONTACT_CENTER');

    if (props.enabled && !enabled) {
        updateCentrals();
    }

    enabled = props.enabled;
}

function addEventListeners() {
    window.addEventListener('WsMessage', (event) => {
        const parsedData = JSON.parse(event.detail.data);

        const monitorStatus = parsedData.monitorStatus;
        if (monitorStatus) {
            eventListeners.forEach((listener) => {
                if (listener.eventType === "onMessage") {
                    listener.callback(parsedData);
                }
            });
        }
    });

    window.addEventListener('SignedIn', () => {
        setEnabled();
    });

    window.addEventListener('SignedOut', () => {
        setEnabled();
    });
}

function updateCentrals() {
    fetchCentrals().then((centrals) => {
        const centralAccess = window.appController?.authorizationService?.getCentralAccess();
        props.centralOptions = centrals.filter(central => centralAccess.find(centralAccess => central.id === centralAccess.centralId));
        updateWsContext();
    });
}

function fetchCentrals() {
    return serviceContainer.httpService.get("centrals")
        .then((response) => response.json);
}

function hideIfMonitor() {
    const isMonitor = window.location.href.endsWith("/#/monitor");
    if (isMonitor) {
        document.getElementById("topbar-app").style.display = "none";
    } else {
        document.getElementById("topbar-app").style.display = "block";
    }
}

hideIfMonitor();

window.addEventListener('AppReady', setup);
